let _ = t => t,
  _t;
import { GYPSUM } from 'HubStyleTokens/colors';
import styled from 'foundations-theming/utils';
import { breakpoint } from 'pricing-pages-ui-components/constants/Breakpoints';
const UnavailableProductLevelButton = styled.div.withConfig({
  displayName: "UnavailableProductLevelButton",
  componentId: "sc-127eil6-0"
})(["width:calc(100% / 3);background-color:", ";font-size:14px;", ""], GYPSUM, breakpoint.phone(_t || (_t = _`
    display: none;
  `)));
export default UnavailableProductLevelButton;